import { GMN } from "@nens/brostar/openapi-client";
import {
  EditGMNMeasuringPointTask,
  qualityRegimeOptionsType,
} from "@nens/brostar/uploadapi-client";

import { GmnMeasuringPointNoStart } from "@/queries/query-gmn-measuring-point";

import { isValidEnum } from "./is-valid-enum";

// EDIT
export const convertGMNMeasuringPointToEditTask = (
  { qualityRegime, broId, deliveryAccountableParty }: GMN,
  {
    tubeStartDate,
    tubeEndDate,
    measuringpointCode,
    gmwBroId,
    tubeNumber,
    eventType,
  }: GmnMeasuringPointNoStart
): EditGMNMeasuringPointTask => {
  if (!eventType) eventType = "GMN_MeasuringPoint";

  const tubeDate = eventType === "GMN_MeasuringPointEndDate" ? tubeEndDate : tubeStartDate;
  const eventDate = tubeDate?.toISOString().slice(0, 10) ?? "";
  return {
    metadata: {
      broId: broId,
      projectNumber: "",
      qualityRegime: isValidEnum(qualityRegimeOptionsType, qualityRegime),
      deliveryAccountableParty: deliveryAccountableParty ?? "",
      correctionReason: "eigenCorrectie",
    },
    sourcedocumentData: {
      eventType: eventType,
      measuringPointCode: measuringpointCode ?? "",
      broId: gmwBroId ?? "",
      tubeNumber: tubeNumber ?? "",
      eventDate: eventDate,
    },
  };
};
